export default __webpack_public_path__ + "static/media/logoRoca2.0f2ae2e5.png";